(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["figma-image-slider"] && !Shopify.designMode) return;
  try {
    

    $('.figma-image-slider').slick({
    slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  infinite: true,
  arrows: false,
  autoplaySpeed: 000,
  speed: 8000,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 2,
      }
    }
  ]
});
 
  
  console.log('figma image slider ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["figma-text-image-slider"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.figma-text-image-slider').slick({
      autoplay: false,
      dots: false,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      pauseOnHover: true,
      infinite: true,
      adaptiveWidth: true
    });
  });
  
  console.log('figma text image slider ');

  } catch(e) { console.error(e); }
})();
})();
